import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CancelEditCustomerList(props) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const { isOpen, submitAction, isEditMode } = props;

    const onCloseDialogReject = (event, reason) => {
        if (event && reason === "backdropClick") {
            return false;
        }
        props.setIsOpen(false);
    }

    const onClickBtnConfirm = () => {
        submitAction();
        props.setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseDialogReject(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {isEditMode ? trI18n('USER12MSG010') : trI18n('USER09MSG001')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onClickBtnConfirm}
                >
                    {trI18n('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
